const NavigationSystem = () => (
  <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5615 22.1309C10.5615 19.3694 12.8001 17.1309 15.5615 17.1309H17.8267H25.0919L40.3018 17.1309H54.5824C57.3438 17.1309 59.5824 19.3694 59.5824 22.1309V41.574V47.1458C59.5824 49.9072 57.3438 52.1458 54.5824 52.1458H52.5108L15.5615 52.1458C12.8001 52.1458 10.5615 49.9072 10.5615 47.1458V44.0551L10.5615 30.0981L10.5615 22.1309Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M14.8125 26.7981L14.8125 23.9074C14.8125 22.8029 15.7079 21.9074 16.8125 21.9074H20.0133M20.0133 21.9074L18.2741 20.168M20.0133 21.9074L18.2741 23.6466"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_4042_158179)">
      <path
        d="M32.6722 49.1131C32.4706 49.2018 32.3698 49.2461 32.3079 49.2266C32.2543 49.2098 32.2123 49.1678 32.1954 49.1142C32.1758 49.0524 32.22 48.9515 32.3085 48.7498L34.819 43.0259C34.8989 42.8438 34.9388 42.7528 34.9946 42.7249C35.0431 42.7007 35.1001 42.7007 35.1486 42.7249C35.2044 42.7528 35.2443 42.8438 35.3242 43.0259L37.8347 48.7498C37.9232 48.9515 37.9674 49.0524 37.9478 49.1142C37.9309 49.1678 37.8889 49.2098 37.8353 49.2266C37.7734 49.2461 37.6726 49.2018 37.471 49.1131L35.1827 48.1062C35.1418 48.0882 35.1213 48.0792 35.1001 48.0756C35.0812 48.0725 35.062 48.0725 35.0431 48.0756C35.0219 48.0792 35.0014 48.0882 34.9605 48.1062L32.6722 49.1131Z"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <line x1="28.0625" y1="52.1338" x2="28.0625" y2="16.4802" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M41.9326 52.084V45.9287C41.9326 43.7196 43.7235 41.9287 45.9326 41.9287H59.1533"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M41.9326 17.1523V24.0635C41.9326 26.2726 43.7235 28.0635 45.9326 28.0635H59.2265"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <rect x="34.5723" y="35.167" width="1" height="4" rx="0.5" fill="currentColor" />
    <rect
      x="48.3154"
      y="34.4805"
      width="1"
      height="4"
      rx="0.5"
      transform="rotate(90 48.3154 34.4805)"
      fill="currentColor"
    />
    <rect
      x="55.8154"
      y="34.4805"
      width="1"
      height="4"
      rx="0.5"
      transform="rotate(90 55.8154 34.4805)"
      fill="currentColor"
    />
    <rect x="34.5713" y="27.667" width="1" height="4" rx="0.5" fill="currentColor" />
    <rect x="34.5684" y="20.167" width="1" height="4" rx="0.5" fill="currentColor" />
    <defs>
      <clipPath id="clip0_4042_158179">
        <rect width="8.27484" height="8.27484" fill="white" transform="translate(29.2207 47.3262) rotate(-45)" />
      </clipPath>
    </defs>
  </svg>
);

export default NavigationSystem;
